import homesideCopy from './customers/homeside/assets/copy.json';
import lowerCopy from './customers/lower/assets/copy.json';
import lwrCopy from './customers/lwr/assets/copy.json';
import defaultCopy from './customers/default/assets/copy.json';
import ozlendingCopy from './customers/ozlending/assets/copy.json';
import opendoorCopy from './customers/opendoor/assets/copy.json';
import powertpoCopy from './customers/powertpo/assets/copy.json';

const copy = {
  DefaultBrand: defaultCopy,
  HomesideBrand: homesideCopy,
  LowerBrand: lowerCopy,
  LwrBrand: lwrCopy,
  OpendoorBrand: opendoorCopy,
  OzLendingBrand: ozlendingCopy,
  PowerTpoBrand: powertpoCopy,
};

export default copy;
